<template>
    <div class="q-pa-md">
        <q-tabs align="left" v-model="activeTab">
            <q-tab :label="'ESET' + ' (' + esetOrdersCount + ')'" class="text-blue" name="ESET" />
        </q-tabs>
        <div class="position-absolute" style="right: 15px;top:75px;z-index: 1">
            <div class="d-flex">
                <!-- <div @click="exportDialog = true" class="export-button mr-2">
                    <q-tooltip>Export</q-tooltip>
                    <div class="mt-1"><img alt="" src="../../assets/share.png"></div>
                </div> -->
                <q-input v-if="activeTab === 'ESET'" class="searchBox" debounce="800" placeholder="Search"
                    style="width: 300px" v-model="esetFilter">
                    <template v-slot:prepend>
                        <q-icon name="search" />
                    </template>
                </q-input>
            </div>
        </div>
        <q-dialog position="right" v-model="ESETDialog">
            <q-card v-if="ESETDialog" style="min-width: 1200px !important; min-height: 95vh;">
                <q-card-section>
                    <div class="row">
                        <div class="d-flex col-12 pt-0"
                            style="justify-content: space-between; align-items: center ">
                            <div>
                                <h4 style="font-size: 22px; font-weight: 300;"> Retail Sales Details </h4>
                            </div>
                            <div class="drawerButtons d-flex" style="margin-top: -10px;">
                                <!-- <q-btn class="" flat round @click.stop="onEditRetailSalesOrder(selectedOrderObj, activeTab)">
                                    <q-tooltip>Edit Order</q-tooltip>
                                    <i class="material-icons"
                                        style="font-size: 16px;color: #777777;margin-right: 5px">edit</i>
                                </q-btn> -->
                                <q-btn @click="ESETDialog = false" flat icon="close" round size="small"></q-btn>
                            </div>
                        </div>
                        <div class="col-4 q-pa-md" style="border-right: 1px solid lightgray">
                            <ul style="list-style: none">
                                <li class="pb-3" style="border-bottom: 1px solid #e0e0e0"></li>
                                <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                                    <span class="bankLabel d-block">Order ID</span>
                                    <h4 style="font-size: 24px; font-weight: 400">
                                        {{ selectedOrderObj.Order ? selectedOrderObj.Order.orderNumber : '-' }}</h4>
                                </li>
                                <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                                    <span class="bankLabel d-block">Placed By</span>
                                    <span>{{ selectedOrderObj.Order ? selectedOrderObj.Order.OrderByUser?.name : '-'
                                        }}</span>
                                </li>
                                <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                                    <span class="bankLabel d-block">Customer Name</span>
                                    <span>{{ selectedOrderObj.Customer ? selectedOrderObj.Customer.name : '-'
                                        }}</span>
                                </li>
                                <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                                    <span class="bankLabel d-block">Company Name</span>
                                    <span>{{ (selectedOrderObj.Customer && selectedOrderObj.Customer.companyName) ||
            '-'
                                        }}</span>
                                </li>
                                <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                                    <span class="bankLabel d-block">Customer Mobile</span>
                                    <span>{{ selectedOrderObj.Customer ? selectedOrderObj.Customer.mobile : '-'
                                        }}</span>
                                </li>
                                <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                                    <span class="bankLabel d-block">Customer Email</span>
                                    <span>{{ selectedOrderObj.Customer ? selectedOrderObj.Customer.email : '-'
                                        }}</span>
                                </li>
                                <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                                    <span class="bankLabel d-block">Invoice No</span>
                                    <!-- <span>{{ selectedOrderObj.invoiceNumber ? selectedOrderObj.invoiceNumber : '-'
                                        }}</span> -->
                                    -
                                </li>
                                <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                                    <span class="bankLabel d-block">Invoice Date</span>
                                    <!-- <span>{{ selectedOrderObj.invoiceDate ? dateFilter(selectedOrderObj.invoiceDate) : '-' }}</span> -->
                                    -
                                </li>
                                <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                                    <span class="bankLabel d-block">Activation Date</span>
                                    <span>{{ selectedOrderObj.activationDate ?
            dateFilter(selectedOrderObj.activationDate) : '-'
                                        }}</span>
                                </li>
                                <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                                    <span class="bankLabel d-block">Created On</span>
                                    <span>{{ selectedOrderObj.createdAt ? dateTimeFilter(selectedOrderObj.createdAt) :
            '-'
                                        }}</span>
                                </li>
                                <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                                    <span class="bankLabel d-block">Invoice Note</span>
                                    <!-- <span>{{ selectedOrderObj.invoiceNote ? selectedOrderObj.invoiceNote : '-' }}</span> -->
                                    -
                                </li>
                            </ul>
                        </div>
                        <div class="col-8 q-pa-md" style="height: 80vh; overflow-y: auto">
                            <!-- <h6 style="margin-top: -18px;margin-bottom: 10px;">Total Items :
                                {{
            selectedOrderObj.Order ?
                selectedOrderObj.Order.totalQty :
                0
        }}</h6> -->
                            <div v-show="batch_loader">
                                <q-inner-loading :showing="true"
                                    style="top: 200px;width: 430px;height: 40px;left: 450px;">
                                    <q-spinner-dots color="primary" size="50px"></q-spinner-dots>
                                </q-inner-loading>
                            </div>

                            <template v-if="productArr && productArr.length">
                                <template v-for="(product, index) in productArr">
                                    <template v-if="product">
                                        <q-card class="product-card mb-3" v-for="(orderItem, i) in [product]"
                                            :key="'serial-' + index + i">
                                            <q-card-section>
                                                <div class="mp-card">
                                                    <div class="mp-header">
                                                        <div class="d-flex justify-content-between"
                                                            style="align-items: center">
                                                            <div class="d-flex">
                                                                <div class="text-left mr-5">
                                                                    <span class="bankLabel">Serial</span>
                                                                    <h4
                                                                        style="font-size: 22px; line-height: 1.5rem; font-weight: 300; ">
                                                                        {{ orderItem?.serialNumber || '-' }}</h4>
                                                                </div>
                                                                <div class="ml-5 text-left">
                                                                    <span class="bankLabel">Product</span>
                                                                    <h4
                                                                        style="font-size: 16px; line-height: 1.5rem; font-weight: 100; ">
                                                                        {{ orderItem?.productName || '-' }}</h4>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <hr class="my-2" style="border: 0.5px solid lightgray">

                                                    <div class="mp-body">
                                                        <ul style="list-style: none">
                                                            <div class="d-flex justify-content-between"
                                                                style="align-items: center">
                                                                <div class="d-flex py-3">
                                                                    <li>
                                                                        <div>
                                                                            <span class="bankLabel">Activation
                                                                                Date</span>
                                                                            <div class="mp-value">
                                                                                <span>{{ orderItem?.activationDate || '-' }}</span>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                    <li style="margin-left: 70px;">
                                                                        <div>
                                                                            <span class="bankLabel">Expiry Date</span>
                                                                            <div class="mp-value">
                                                                                <span>{{ orderItem?.expiryDate || '-' }}</span>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                    <li style="margin-left: 70px;">
                                                                        <div>
                                                                            <span class="bankLabel">Product Key</span>
                                                                            <div class="mp-value">
                                                                                <span>{{ orderItem?.productKey || '-' }}</span>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                </div>

                                                            </div>

                                                        </ul>

                                                    </div>
                                                </div>
                                            </q-card-section>
                                        </q-card>
                                    </template>
                                </template>
                            </template>
                            <!-- <q-list bordered class="rounded-borders" v-if="productArr && productArr.length">
                   <template v-for="(product, index) in productArr" v-if="product.OrderItems.length">
                     <q-expansion-item>
                       <template slot="header">
                         <q-item-section> {{ product.name }}</q-item-section>
                         <q-item-section side>{{ product.OrderItems.length }}</q-item-section>
                       </template>
                       <q-card>
                         <q-card-section>
                           <q-list bordered padding>
                             <q-item :key="i" tag="label" v-for="(orderItem, i) in product.OrderItems">
                               <q-item-section side top></q-item-section>
                               <q-item-section>
                                 <q-item-label>{{ orderItem.ProductInventory.serial }}
                                   <span style="float:right;"></span>
                                 </q-item-label>
                                 <q-item-label caption>
                                   <span>Activation-date: {{
                                       dynamicDateFormatter(orderItem.meta.activationDate, 'DD-MM-YYYY', 'DD/MM/YYYY')
                                     }} | </span>
                                   <span>Expiry-date: {{
                                       dynamicDateFormatter(orderItem.meta.expiryDate, 'DD-MM-YYYY', 'DD/MM/YYYY')
                                     }} </span>
                                   <span
                                       v-if="orderItem.meta.productKey"> | Product-key: {{
                                       orderItem.meta.productKey
                                     }}</span>
                                 </q-item-label>
                               </q-item-section>
                             </q-item>
                           </q-list>
                         </q-card-section>
                       </q-card>
                     </q-expansion-item>
                   </template>
                 </q-list> -->
                        </div>
                    </div>
                </q-card-section>
            </q-card>
        </q-dialog>
        <q-dialog content-class="my-special-class" persistent position="right" v-model="retailSalesDialog">
            <retail-sales @closeRetailSalesDialog="retailSalesDialog = false" ref="place-retail-sales" />
        </q-dialog>
        <div v-if="activeTab === 'ESET'">
            <q-table :pagination-label="getESETPaginationLabel" :loading="esetOrderLoader"
                @request="updatePagination('', $event)" :columns="ESETColumns" :pagination.sync="paginationESET"
                :data="esetOrders" class="table-header" flat table-class="table-class" v-show="activeTab === 'ESET'"
                binary-state-sort :rows-per-page-options="[]">

                <template v-slot:body="props">
                    <q-tr style="height: 5px"></q-tr>
                    <q-tr @click.native="openOrderDetail(props.row, activeTab)" :props="props" class="tableItems">
                        <q-td :props="props" key="orderId">
                            {{ props.row.Order ? props.row.Order.orderNumber : '-' }}
                            <!-- {{ props.row.Order.orderNumber ? '#' + props.row.Order.orderNumber : '-' }} -->
                        </q-td>
                        <q-td :props="props" key="placedBy">
                            {{ props.row.Order ? props.row.Order.OrderByUser.name : '-' }}
                        </q-td>

                        <q-td :props="props" key="customerMobile">
                            {{ props.row.Customer ? props.row.Customer.mobile : '-' }}
                        </q-td>
                        <q-td :props="props" key="customerEmail">
                            {{ props.row.Customer ? props.row.Customer.email : '-' }}
                        </q-td>

                        <q-td :props="props" key="orderFrom">
                            {{ props.row.Organization ? props.row.Organization.name : '-' }}
                        </q-td>
                        <q-td :props="props" key="orderTo">
                            {{ props.row.Customer ? props.row.Customer.name : '-' }}
                        </q-td>

                        <q-td :props="props" key="date">
                            {{ props.row.activationDate ? dateFilter(props.row.activationDate) : '-' }}
                        </q-td>

                        <q-td :props="props" key="createdOn">
                            {{ props.row.createdAt ? dateTimeFilter(props.row.createdAt) : '-' }}
                        </q-td>

                        <q-td :props="props" key="invoiceNo">
                            <!-- {{ props.row.invoiceNumber ? props.row.invoiceNumber : '-' }} -->
                            -
                        </q-td>
                        <q-td :props="props" key="invoiceDate">
                            <!-- {{ props.row.invoiceDate ? dateFilter(props.row.invoiceDate) : '-' }} -->
                            -
                        </q-td>
                        <!-- <q-td :props="props" key="itemCount">
                            {{ props.row.Order ? props.row.Order.totalQty : '-' }}
                        </q-td> -->
                    </q-tr>
                </template>

                <template v-slot:no-data="{ icon, message, filter }">
                    <div class="full-width row flex-center q-gutter-sm">
                        <div>
                            <img alt="" class="d-block mx-auto " src="../../assets/no_Data.png" style="width: 25%;">
                            <h6 class="text-center">No data available</h6>
                        </div>
                    </div>
                </template>

                <template v-slot:pagination="scope">
                    <div class="mt-2">{{ getESETPaginationLabel() }}</div>
                    <q-btn icon="chevron_left" color="grey-8" round dense flat :disable="paginationESET.offset === 0"
                        @click="updatePagination('subtract')" />
                    <q-btn icon="chevron_right" color="grey-8" round dense flat
                        :disable="(paginationESET.offset + paginationESET.limit) > paginationESET.rowsNumber"
                        @click="updatePagination('add')" />
                </template>
            </q-table>
        </div>
        <q-dialog content-class="my-special-class" persistent position="right" v-model="updateRS_ESET_Dialog">
            <UpdateRetailSales :orgId="userObj.orgId" @closeUpdateRSDialog="updateRS_ESET_Dialog=false"
                ref="update-retail-sales" />
        </q-dialog>
        <export-retail-sales :exportDialog.sync="exportDialog" />
    </div>
</template>

<script>
import { GET_ORDER_SKU_GROUPBY_PRODUCT } from '@/graphql/queries/Orders'
import RetailSales from '../RetailSales/RetailSales'
import UpdateRetailSales from '../RetailSales/UpdateRetailSales'
import moment from 'moment'
import Constants from '@/Constants/Constant'
import axios from 'axios';
import ExportRetailSales from "../RetailSales/ExportRetailSales";

export default {
    components: { ExportRetailSales, UpdateRetailSales, RetailSales },
    apollo: {
        $subscribe: {
            // esetOrdersCount: {
            //     query: SUBSCRIBE_RETAIL_ORDERS_TOTALCOUNT,
            //     variables() {
            //         return {
            //             filter: this.combineESETFilter, orgId: this.userObj.orgId, status: 'Sold',
            //         }
            //     },
            //     result({ data }) {
            //         this.esetOrdersCount = data.esetOrdersCount.aggregate.count
            //         this.paginationESET.rowsNumber = this.esetOrdersCount
            //         this.$forceUpdate()
            //         this.$emit('esetOrdersCount', this.esetOrdersCount)
            //     },
            // },
            // esetOrders: {
            //     query: SUBSCRIBE_RETAIL_SALES_ORDERS,
            //     fetchPolicy: 'network-only',
            //     variables() {
            //         return {
            //             sortObj: this.paginationESET.sortObj,
            //             orgId: this.userObj.orgId, offset: this.paginationESET.offset,
            //             limit: this.paginationESET.limit, filter: this.combineESETFilter,
            //         }
            //     },
            //     result({ data }) {
            //         this.esetOrders = data.esetOrders
            //         this.esetOrderLoader = false
            //     },
            // },
        },
    },
    name: 'RetailSalesVAPOffline',
    data: function () {
        return {
            isLoading: false,
            AIPL_ORGID: Constants.AIPL_ORGID,
            userObj: JSON.parse(localStorage.getItem('user')),
            ESETDialog: false,
            esetOrders: [], productArr: [],
            selectedOrderObj: '',
            esetOrderLoader: true, batch_loader: false,      //For orderDetail dialog
            esetOrdersCount: 0,
            esetFilter: '', combineESETFilter: '%%',
            activeTab: 'ESET',
            paginationESET: {
                rowsPerPage: 50, rowsNumber: 0, limit: 50, offset: 0, page: 1,
                sortBy: 'createdOn', orderBy: 'desc_nulls_last', sortObj: {},
            },
            retailSalesDialog: false, addNewSupportPlanDialog: false,
            updateRS_ESET_Dialog: false,
            ESETColumns: [
                { name: 'orderId', label: 'Order ID', field: 'orderId', align: 'left', sortable: false },
                { name: 'placedBy', label: 'Placed By', field: 'placedBy', align: 'left', sortable: false },
                { name: 'customerMobile', label: 'Mobile', field: 'customerMobile', align: 'left', sortable: false },
                { name: 'customerEmail', label: 'Email', field: 'customerEmail', align: 'left', sortable: false },
                { name: 'orderFrom', label: 'Order From', field: 'orderFrom', align: 'left', sortable: false },
                { name: 'orderTo', label: 'Order To', field: 'orderTo', align: 'left', sortable: false },
                { name: 'date', label: 'Activation Date', field: 'date', align: 'left', sortable: true },
                { name: 'createdOn', label: 'Created On', field: 'createdOn', align: 'left', sortable: true },
                { name: 'invoiceNo', label: 'Invoice No', field: 'invoiceNo', align: 'left', sortable: false },
                { name: 'invoiceDate', label: 'Invoice Date', field: 'invoiceDate', align: 'left', sortable: true },
                // { name: 'itemCount', label: 'Items', field: 'itemCount', align: 'left', sortable: false },
            ],
            exportDialog: false
        }
    },
    created() {
        this.loadData();
    },
    watch: {
        'esetFilter': function (val) {
            this.esetOrders = []
            this.esetOrderLoader = true
            this.combineESETFilter = '%' + val + '%'
            this.paginationESET.offset = 0
            this.loadData()
        },
    },
    methods: {
        async loadData() {
            if (this.isLoading) return;
            this.isLoading = true;
            // const apiUrl = Constants.graphql_backend_url + 'rest/online/retail/sales';
            const apiUrl = Constants.graphql_backend_url + 'rest/online/partner/retail/sales';
            try {
                const responseCount = await axios.post(apiUrl, {
                    orgId: this.userObj.orgId
                });

                this.esetOrdersCount = responseCount.data.OnlineRetailSales.length;

                const response = await axios.post(apiUrl, {
                    offset: this.paginationESET.offset * this.paginationESET.limit,
                    limit: this.paginationESET.limit,
                    orgId: this.userObj.orgId,
                    // orgId: "8d3db3b5-cb7c-51f1-3cec-263eb7f8b34c"
                    // filter: this.combineESETFilter,
                });

                  const newItems = response.data.OnlineRetailSales;

                // this.esetOrders = response.data.OnlineRetailSales;
                this.paginationESET.rowsNumber = this.esetOrdersCount
                this.esetOrderLoader = false;

                  if (newItems.length > 0) {
                    this.esetOrders = [...this.esetOrders, ...newItems];
                  }
            } catch (error) {
                this.isLoading = false;
                this.esetOrderLoader = false;

                console.error('Error fetching data', error);
            } finally {
                this.isLoading = false;
                this.esetOrderLoader = false;
            }
        },
        updatePagination(operation, requestProp) {
            if (operation === 'add') {
                if (this.activeTab === 'ESET') {
                    if (this.paginationESET.rowsNumber > (this.paginationESET.limit + this.paginationESET.offset)) {
                        this.esetOrderLoader = true
                        this.paginationESET.offset = this.paginationESET.limit + this.paginationESET.offset
                    }
                }
            } else if (operation === 'subtract') {
                if (this.activeTab === 'ESET') {
                    if (0 !== this.paginationESET.offset) {
                        this.esetOrderLoader = true
                        this.paginationESET.offset = this.paginationESET.offset - this.paginationESET.limit
                    }
                }
            }
            if (requestProp) {
                let sortKey = requestProp.pagination.sortBy
                if (this.activeTab === 'ESET') {
                    this.esetOrderLoader = true
                    this.paginationESET.offset = 0
                    this.paginationESET.orderBy = this.paginationESET.orderBy === 'desc_nulls_last'
                        ? 'asc_nulls_last'
                        : 'desc_nulls_last'
                    this.paginationESET.sortObj = {}
                    this.paginationESET.sortBy = sortKey
                    this.paginationESET.sortObj[this.paginationESET.sortBy] = this.paginationESET.orderBy
                }
            }
        },
        getESETPaginationLabel() {
            let start, end
            start = this.paginationESET.offset + 1
            if (this.paginationESET.offset > 0) {
                if ((this.paginationESET.limit + this.paginationESET.offset) > this.paginationESET.rowsNumber)
                    end = this.paginationESET.rowsNumber
                else
                    end = this.paginationESET.offset + this.paginationESET.limit
            } else if (this.paginationESET.offset === 0) {
                end = this.paginationESET.limit
            }
            return `${start}-${end} of ${this.paginationESET.rowsNumber}`
        },
        onEditRetailSalesOrder(order, activeTab) {
            if (activeTab === 'ESET') {
                this.updateRS_ESET_Dialog = true
                setTimeout(() => {
                    this.$refs['update-retail-sales'].assignValues(order)
                }, 100)
                this.ESETDialog = false
            }
        },
        openOrderDetail(order, activeTab) {
            this.selectedOrderObj = order
            this.productArr = []
            this.batch_loader = true
            activeTab === 'ESET' ? this.ESETDialog = true : ''
            setTimeout(() => {
                this.getOrderSkuGroupByProduct(order.id)
            }, 400)
        },
        async getOrderSkuGroupByProduct(orderId) {
            const apiUrl = Constants.graphql_backend_url + 'rest/retail/sale/detail';
            let response = await axios.post(apiUrl, {
                retailSaleId: orderId
            });
            
            if (response.data) {
                const data = response.data.OnlineRetailSales.map(item => ({
                    "productName": item.Product.name,
                    "expiryDate": item.meta.expiryDate,
                    "productKey": item.meta.productKey,
                    "activationDate": item.meta.activationDate,
                    "serialNumber": item.SubBatch.subBatch
                }));
                this.productArr = data
                this.batch_loader = false
            }
        },
    },
}
</script>

<style scoped>
</style>